module.exports = __webpack_public_path__ + "static/media/4.bd3f7c7c.png";